import EvaluacionDetalladaApi from "../api/evaluacionDetalladaApi";

class EvaluacionDetalladaService {
    static async createEvaluacionDetallada(evaluacionData) {
        try {
            const response = await EvaluacionDetalladaApi.createEvaluacionDetallada(evaluacionData);
            return response.data;
        } catch (error) {
            console.error('Error en EvaluacionDetalladaService:', error);
            throw error;
        }
    }

    static async getEvaluacionDetallada(id) {
        try {
            const response = await EvaluacionDetalladaApi.getEvaluacionDetallada(id);
            return response.data;
        } catch (error) {
            console.error('Error en EvaluacionDetalladaService:', error);
            throw error;
        }
    }

    static async getEvaluacionByReclutamiento(reclutamientoId) {
        try {
            const response = await EvaluacionDetalladaApi.getEvaluacionByReclutamiento(reclutamientoId);
            return response.data;
        } catch (error) {
            console.error('Error en EvaluacionDetalladaService:', error);
            throw error;
        }
    }
}

export default EvaluacionDetalladaService; 